(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["my-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const galleryImages = document.querySelectorAll('.gallery-image');
  const overlay = document.getElementById('lightbox');
  const overlayImg = document.getElementById('lightbox-img');
  const overlayClose = document.getElementById('lightbox-close');

  galleryImages.forEach(img => {
    img.addEventListener('click', () => {
      overlay.style.display = 'flex';
      overlayImg.src = img.dataset.full || img.src;
    });
  });

  overlayClose.addEventListener('click', () => {
    overlay.style.display = 'none';
    overlayImg.src = '';
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.style.display = 'none';
      overlayImg.src = '';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
